module.exports = __webpack_public_path__ + "img/calendar-16.f690ef4b.svg";